import { Component, Input } from '@angular/core'

@Component({
  selector: 'app-timeline-view',
  templateUrl: './timeline-view.component.html',
  styleUrls: ['./timeline-view.component.scss'],
})
export class TimelineViewComponent {
  @Input() items: { message: string, date: Date }[] = [];
}
